import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import { useFormik } from "formik";
import * as Yup from "yup";

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem("token");
const DEFAULT_PASSWORD = "User@123"; // Mot de passe par défaut

const validationSchema = Yup.object({
    userName: Yup.string().required("Nom d'utilisateur requis"),
    email: Yup.string().email("Email invalide").required("Email requis"),
    role: Yup.string().required("Rôle requis"),
});
const UserManagement = () => {
    const [users, setUsers] = useState([]);

    const [selectedUser, setSelectedUser] = useState(null);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        fetchUsers();
        fetchRoles();
    } ,[]);

    const fetchUsers = () => {
        axiosInstance.get(`${baseUrl}/api/Users`)
            .then(res => setUsers(res.data))
            .catch(() => console.log("Impossible de charger les utilisateurs"));
    };

    const fetchRoles = () => {
        axiosInstance.get(`${baseUrl}/api/Roles/getAllRoles`)
            .then(res => setRoles(res.data))
            .catch(() => console.log("Impossible de charger rôles"));
    };

    const formik = useFormik({
        initialValues: {
            id: "",
            userName: "",
            email: "",
            role: "",
            isActive: true
        },
        validationSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {

            const url = values.id
                ? `${baseUrl}/api/Users/UpdateUser`
                : `${baseUrl}/api/Users/CreateUser`;

            const payload = {
                id: values.id || "",
                userName: values.userName,
                email: values.email,
                role: values.role,
                isActive: values.isActive,
                password: DEFAULT_PASSWORD
            };

            try {
                await axiosInstance.post(url, payload);

                window.$("#modalForm").modal("hide");

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès",
                    showConfirmButton: false,
                    timer: 2000,
                });

                fetchUsers();
                resetForm();
                setSelectedUser(null);

            } catch (error) {

                // 🔴 erreurs serveur (ModelState / ServiceResponse)
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Opération échouée",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        }
    });


    const resetForm = () => {
        formik.resetForm();
        setSelectedUser(null);
    };

    const handleEdit = (user) => {
        setSelectedUser(user);

        formik.setValues({
            id: user.id,
            userName: user.userName,
            email: user.email,
            role: user.role,
            isActive: user.isActive
        });

        setTimeout(() => {
            window.$("#modalForm").modal("show");
        }, 100);
    };


    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/Users/DeleteUser`,
                    { 'id': 0, 'idString': id })
                    .then(() => fetchUsers())
                    .catch(() => Swal.fire("Erreur", "Suppression échouée", "error"));
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Utilisateurs</h3>
            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" onClick={resetForm}><i className="fas fa-plus"></i>Ajouter</button>

            <DataTableComponent
                data={users.map(user => ({
                    ...user,
                    isActiveDisplay: (
                        <input
                            type="checkbox"
                            checked={user.isActive}
                            disabled
                            style={{ cursor: "not-allowed" }}
                        />
                    )
                }))}
                title="Liste des Utilisateurs"
                columns={["userName", "email", "role", "isActiveDisplay"]}
                columnsMapping={{
                    userName: "Nom d'utilisateur",
                    email: "Email",
                    role: "Rôle",
                    isActiveDisplay: "Actif"
                }}
                keyField="id"
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />

            {/* Modal Form */}
            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedUser ? "Modifier" : "Ajouter"} un utilisateur</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group mb-3">
                                <label>Nom d'utilisateur</label>
                                <input
                                    type="text"
                                    name="userName"
                                    className={`form-control ${formik.touched.userName && formik.errors.userName ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.userName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="invalid-feedback">{formik.errors.userName}</div>
                            </div>

                            <div className="form-group mb-3">
                                <label>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="invalid-feedback">{formik.errors.email}</div>
                            </div>

                            <div className="form-group mb-3">
                                <label>Rôle</label>
                                <select
                                    name="role"
                                    className={`form-control ${formik.touched.role && formik.errors.role ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.role}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">Sélectionner un rôle</option>
                                    {roles.map(r => (
                                        <option key={r.id} value={r.name}>{r.name}</option>
                                    ))}
                                </select>
                                <div className="invalid-feedback">{formik.errors.role}</div>
                            </div>

                            <div className="form-group mb-3">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="isActive"
                                        checked={formik.values.isActive}
                                        onChange={formik.handleChange}
                                    />  Actif
                                </label>
                            </div>
                            {!selectedUser && (
                                <div className="alert alert-info mt-3">
                                    <strong>Mot de passe par défaut : {DEFAULT_PASSWORD}</strong>
                                </div>
                            )}

                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button className="btn btn-primary" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserManagement;
